function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Button from "../Button/Button";

var Pagination = function (_Component) {
    _inherits(Pagination, _Component);

    function Pagination() {
        _classCallCheck(this, Pagination);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Pagination.prototype.pageList = function pageList() {
        var _props = this.props,
            total = _props.total,
            current = _props.current;

        var allowedItems = 5;
        var items = Array.from({ length: total }, function (_, i) {
            return i + 1;
        }); // Fill array with all page numbers
        var firstItem = false;
        var lastItem = false;

        if (total > allowedItems) {
            var currentIndex = current - 1;
            var offset = 2;
            var firstIndex = currentIndex - offset - 1 < 0 ? 0 : currentIndex - offset;

            if (total - current < offset) {
                offset = offset - (total - current);
                firstIndex = firstIndex - offset;
            }

            items = items.slice(firstIndex, allowedItems + firstIndex);
            firstItem = items.includes(1) ? false : 1;
            lastItem = items.includes(total) ? false : total;
        }

        return { firstItem: firstItem, lastItem: lastItem, items: items };
    };

    Pagination.prototype.render = function render() {
        var _props2 = this.props,
            current = _props2.current,
            total = _props2.total,
            next = _props2.next,
            prev = _props2.prev,
            goToPage = _props2.goToPage,
            langNext = _props2.langNext,
            langPrev = _props2.langPrev,
            langGoToPage = _props2.langGoToPage;


        var pageList = this.pageList();

        return React.createElement(
            "nav",
            { "class": "c-pagination u-display--flex u-justify-content--center", role: "navigation", "aria-label": "Pagination Navigation" },
            React.createElement(
                "ul",
                { className: "c-pagination__list" },
                React.createElement(
                    "li",
                    { className: "c-pagination__item--previous c-pagination__item" },
                    React.createElement(
                        Button,
                        {
                            color: "default",
                            onClick: prev,
                            disabled: current === 1,
                            className: "c-pagination__link",
                            size: "small"
                        },
                        React.createElement(
                            "span",
                            { className: "u-sr__only" },
                            langPrev || "Previous page"
                        ),
                        React.createElement(
                            "i",
                            { className: "c-icon c-icon--size-sm material-icons", translate: "no", "aria-hidden": "true" },
                            "chevron_left"
                        )
                    )
                ),
                pageList.firstItem && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                        "li",
                        { className: "c-pagination__item u-display--none@xs" },
                        React.createElement(
                            Button,
                            {
                                color: current === pageList.firstItem ? 'primary' : 'default',
                                onClick: function onClick() {
                                    return goToPage(pageList.firstItem);
                                },
                                disabled: current === pageList.firstItem,
                                className: "c-pagination__link",
                                size: "small"
                            },
                            pageList.firstItem
                        )
                    ),
                    React.createElement(
                        "li",
                        { className: "c-pagination__item u-display--none@xs" },
                        React.createElement(
                            "i",
                            { className: "c-icon c-icon--size-sm material-icons", translate: "no", role: "img", alt: "" },
                            "more_horiz"
                        )
                    )
                ),
                React.createElement(
                    "li",
                    { className: "c-pagination__page-wrapper" },
                    React.createElement(
                        "ul",
                        { className: "c-pagination__pages" },
                        pageList.items.map(function (page, key) {
                            return React.createElement(
                                "li",
                                { className: "c-pagination__item", key: key },
                                React.createElement(
                                    Button,
                                    {
                                        color: current === page ? 'primary' : 'default',
                                        onClick: function onClick() {
                                            return goToPage(page);
                                        },
                                        disabled: current === page,
                                        className: "c-pagination__link",
                                        size: "small"
                                    },
                                    React.createElement(
                                        "span",
                                        { className: "u-sr__only" },
                                        langGoToPage || "Go to page: ",
                                        " "
                                    ),
                                    page
                                )
                            );
                        })
                    )
                ),
                pageList.lastItem && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                        "li",
                        { className: "c-pagination__item u-display--none@xs" },
                        React.createElement(
                            "i",
                            { className: "c-icon c-icon--size-sm material-icons", translate: "no", role: "img", alt: "" },
                            "more_horiz"
                        )
                    ),
                    React.createElement(
                        "li",
                        { className: "c-pagination__item u-display--none@xs" },
                        React.createElement(
                            Button,
                            {
                                color: current === pageList.lastItem ? 'primary' : 'default',
                                onClick: function onClick() {
                                    return goToPage(pageList.lastItem);
                                },
                                disabled: current === pageList.lastItem,
                                className: "c-pagination__link",
                                size: "small"
                            },
                            pageList.lastItem
                        )
                    )
                ),
                React.createElement(
                    "li",
                    { className: "c-pagination__item--next c-pagination__item" },
                    React.createElement(
                        Button,
                        {
                            color: "default",
                            onClick: next,
                            disabled: current === total,
                            className: "c-pagination__link",
                            size: "small"
                        },
                        React.createElement(
                            "span",
                            { className: "u-sr__only" },
                            langNext || "Next page"
                        ),
                        React.createElement(
                            "i",
                            { className: "c-icon c-icon--size-sm material-icons", translate: "no", "aria-hidden": "true" },
                            "chevron_right"
                        )
                    )
                )
            )
        );
    };

    return Pagination;
}(Component);

Pagination.propTypes = process.env.NODE_ENV !== "production" ? {
    current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    next: PropTypes.func.isRequired,
    prev: PropTypes.func.isRequired,
    goToPage: PropTypes.func.isRequired,
    langPrev: PropTypes.string,
    langNext: PropTypes.string,
    langGoToPage: PropTypes.string
} : {};


export default Pagination;